import { render, staticRenderFns } from "./ProductComplementaryPreview.vue?vue&type=template&id=5be5c174&scoped=true&"
import script from "./ProductComplementaryPreview.vue?vue&type=script&lang=js&"
export * from "./ProductComplementaryPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductComplementaryPreview.vue?vue&type=style&index=0&id=5be5c174&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5c174",
  null
  
)

export default component.exports